// ==================== SANDBOX MODE: VISUAL INDICATOR ====================
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API } from '@/App';

export default function TestModeIndicator() {
  const [testMode, setTestMode] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkTestMode();
  }, []);

  const checkTestMode = async () => {
    try {
      const res = await axios.get(`${API}/system/test-mode`);
      setTestMode(res.data.test_mode);
    } catch (error) {
      console.error('Error checking test mode:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading || !testMode) return null;

  return (
    <div className="fixed top-0 left-0 right-0 bg-yellow-500 text-black text-center py-2 px-4 z-50 shadow-lg">
      <div className="flex items-center justify-center gap-2">
        <span className="font-bold">⚠️ MODO DE TESTE ATIVO</span>
        <span className="text-sm">
          Pagamentos não são cobrados. Dados marcados como teste.
        </span>
      </div>
    </div>
  );
}

// ==================== END SANDBOX MODE ====================
